export default __webpack_public_path__ + "ec78c94f0823c7f1d6193c73e227a21c.png";